<template>
  <div class="page">
    <p class="p1">
      套餐列表
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="head">
      <div>
        <p class="head-p" v-for="(item,index) in iccids" :key="index">
          <span>ICCID{{index + 1}}：</span>
          <span>{{item}}</span>
        </p>
      </div>
    </div>
    <p class="kong"></p>
    <div class="middle">
      <ul class="middle-ul">
        <li v-for="(item,index) in packageList" :key="index" @click="payDetails(item,index)" :class="{selectClass:cardIndex === index}">
          <i :class="{recommend: item.flowInfo === '[1]'}"></i>
          <p>
            <span class="span1">{{item.productName}}</span>
            <span class="span4">¥{{item.price}}</span>
          </p>
          <p>
            <span class="span2">{{item.remark}}</span>
            <span class="span3">¥{{item.showPrice}}</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { wx_userProduct } from "@/api/api.js"; //提交iccids获取数据
export default {
  data() {
    return {
      // 套餐列表
      cardIndex:0,
      packageList:[],
      msisdn:"",
      wechatId:"",
      propsParams:{},
      iccids:[],
      transId:""
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    // 获取套餐
    getMeal(){
      this.$toast.loading('加载中...',{ 
        duration:200,
        coverColor: "rgba(0,0,0,0.5)",
        closeOnClickOverlay: true,
        loadingRotate:true
      });
      let params ={
        iccids:this.$store.state.user.iccids,
        channel:localStorage.getItem("channel")
      }
      wx_userProduct(params).then(res => {
        if(res.data.code == 200 ){
          this.iccids = res.data.data.iccids;
          this.packageList = res.data.data.wxProductList;
          this.wechatId = res.data.data.appId;
          this.transId = res.data.data.transId;
        }else{
          this.$toast.warn(res.data.message);
          setTimeout(() => {
            this.goBack()
          }, 2000);
        }
      })
    },
    // 切换列表
    payDetails(val,index){
      this.propsParams = val;
      this.cardIndex = index;
      sessionStorage.setItem('wechatId',this.wechatId);
      sessionStorage.setItem('id',this.propsParams.productId);
      sessionStorage.setItem('transId',this.transId);
      const url = "http://" + window.location.host + "/dist/#/userCenter/uesrOrderQr";
      const callbackURL = encodeURIComponent(url);
      const wechatId = this.wechatId;
      const redirectURI = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatId}&redirect_uri=${callbackURL}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
      location.replace(redirectURI);
    },
  },
  created() {},
  mounted(){
    window.document.title = "套餐列表";
    this.getMeal();
  }
};
</script>
<style scoped lang="less">
  .page{
    .p1{
        text-align: center;
        height: 40px;
        line-height: 40px;
        background: #F94040;
        color: #fff;
        font-size: 18px;
        position: relative;
        .rt-pos{
          position: absolute;
          left: 20px;
          top:14px;
          width: 12px;
          height: 12px;
          border-top: 2px solid gainsboro;
          border-left: 2px solid gainsboro;
          transform: rotate(-45deg);
        }
      }
    .head{
      padding: 10px;
      box-sizing: border-box;
      .head-p{
        margin-top: 5px;
        font-size: 13px;
      }
    }
    .kong{
      width: 100%;
      height: 15px;
      background: #EDEDED;
    }
    .middle{
      width: 100%;
      padding-bottom: 75px;
      .middle-ul{
        width: 100%;
        padding-bottom: 8px;
        box-sizing: border-box;
        li{
          width: 95%;
          margin: 0 auto;
          margin-top: 20px;
          border: 3px solid #EDEDED;
          border-radius: 8px;
          position: relative;
          .recommend {
            background: url(../../assets/img/recommend.svg)no-repeat;
            width: 40px;
            height: 40px;
            position: absolute;
            left: 0;
            top: 0;
            background-size: 110%;
          }
          p{
            padding: 10px;
            display: flex;
            justify-content: space-between;
            .span1{
              font-size: 16px;
              font-weight: 700;
              margin-left: 5px;
            }
            .span2{
              display: inline-block;
              width: 75%;
            }
            .span3{
              text-decoration: line-through;
            }
            .span4{
              font-size: 26px;
              color:#F94040;
            }
          }
        }
      }
    }
    .footer{
      background: #F8F8F8;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      padding: 15px 0;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
  }
</style>

